/* Note: I'm using any and type aliases here instead of ReduxState because it's an incorrect typing for the store, we need to create the RootState type
and it implies a big refactor. */

import { PaymentStep } from 'lib/enums/payments.enums'
import { IPlanInformation, ISelectedRecurrentPlan } from 'models/payments'
import { RootState } from 'store/reducers'

export const selectPaymentStep = (store: RootState) =>
  store.payments.paymentStep as PaymentStep

export const selectSelectedRecurrentPlan = (store: RootState) =>
  store.payments.selectedRecurrentPlan as ISelectedRecurrentPlan

export const selectIsRecurringPayment = (store: RootState) =>
  store.payments.isRecurringPayment as boolean

export const selectSelectedPayment = (store: RootState) =>
  store.payments.selectedPlan as IPlanInformation
